<template>
  <div>
    <div v-if="gdata!==null">
      <div class="dashboardHeader row">
        <div class="col-6">
          <b-form-select :options="products" name="ddlSelect" v-model="selectedProduct" @change="doCustomProduct"></b-form-select>
        </div>
        <div class="col-6">
          <div class="pull-right">
            <span name="filter">Filter:</span>
            <b-form-select v-model="dashDelta" class="ib" @change="selectTime">
              <b-form-select-option value="-" id="alltime">All Time</b-form-select-option>
              <b-form-select-option value="7776000000" id="past90days">Past 90 Days</b-form-select-option>
              <b-form-select-option value="5184000000" id="past60days">Past 60 Days</b-form-select-option>
              <b-form-select-option value="2592000000" id="past30days">Past 30 Days</b-form-select-option>
              <b-form-select-option value="1209600000" id="past14days">Past 14 Days</b-form-select-option>
              <b-form-select-option value="604800000" id="past7days">Past 7 Days</b-form-select-option>
              <b-form-select-option value="custom" id="custom_timeframe">Custom Timeframe</b-form-select-option>
            </b-form-select>
            &nbsp;&nbsp;
            <b-button v-b-modal.lGroups class="ib btn btn-secondary" v-if="mode==='0'" id="filterbygroup" @click="openGroupsModel">
              Filter by Group
            </b-button>
            &nbsp;&nbsp;

            <b-button class="ib btn btn-secondary" @click="clearFilters" id="clearfilter">
              Clear Filters
            </b-button>
          </div>
          <div class="clearfix"></div>
        </div>

      </div>
      <div v-if="dashHasData===true" class="dashboardBody row mt-2">
        <div class="col-4">
          <div class="usersLaunched dashhead moduleCard">
            <h3 id="logindata">Login Data</h3>
            <div class="row offsetrow">
              <div id="loggedin" class="col-8 text-left">
                Logged In:
              </div>
              <div class="col-4 text-right">
                {{LoggedIn}} <font-awesome-icon icon="user" @click="showPopLogin(0)" size="lg" title="Get list of users that logged in"></font-awesome-icon>
              </div>
            </div>
            <div class="row">
              <div id="didnotloggedin" class="col-8 text-left">
                Did Not Log In:
              </div>
              <div class="col-4 text-right">
                {{DidNotLogin}} <font-awesome-icon icon="user" @click="showPopLogin(1)" size="lg" title="Get list of users that did not log in"></font-awesome-icon>
              </div>
            </div>
          </div>
          <div class="launchGraph dashbox moduleCard mt-2" v-if="compdata!==null&&compoptions!==null">
            <h3 class="text-center" id="memberlaunches">Member Launches</h3>
            <dash-line :data="compdata" :options="compoptions"></dash-line>
          </div>
        </div>
        <div class="col-4">
          <div class="completionData dashhead moduleCard">
            <h3 id="completiondata">Usage & Completion Data</h3>
            <!--<div class="row offsetrow">
              <div id="completedproduct" class="col-8 text-left">
                Completed Product(s):
              </div>
              <div class="col-4 text-right">
                {{Completed}} <font-awesome-icon icon="user" @click="showPopLogin(2)" size="lg" aria-label="Get list of users that completed product"></font-awesome-icon>
              </div>
            </div>
            <div class="row">
              <div id="didnotcompleteproduct" class="col-8 text-left">
                Did Not Complete Product(s):
              </div>
              <div class="col-4 text-right">
                {{DidNotComplete}} <font-awesome-icon icon="user" @click="showPopLogin(3)" size="lg" aria-label="Get list of users that did not complete product"></font-awesome-icon>
              </div>
            </div>-->
            <div class="row offsetrow">
              <div id="completedproduct" class="col-8 text-left">
                No Activity:
              </div>
              <div class="col-4 text-right">
                {{NeverStarted}} <font-awesome-icon icon="user" @click="showPopLogin(6)" size="lg" title="Users who did not start the product(s) during the selected time filter."></font-awesome-icon>
              </div>
            </div>
            <div class="row">
              <div id="didnotcompleteproduct" class="col-8 text-left">
                Did Not Finish:
              </div>
              <div class="col-4 text-right">
                {{StartedButNoScore}} <font-awesome-icon icon="user" @click="showPopLogin(7)" size="lg" title="Users who have started the product(s) during the selected time filter, but never received a score."></font-awesome-icon>
              </div>
            </div>
            <div class="row">
              <div id="failed80percent" class="col-8 text-left">
                <!--Failed (Never 80% or Higher):-->
                Below Passing Scores (<80%):
              </div>
              <div class="col-4 text-right">
                {{Failed}} <font-awesome-icon icon="user" @click="showPopLogin(5)" size="lg" title="Users who have received at least one score using the product(s) during the selected time filter, and all the scores were 79 or below in that timeframe."></font-awesome-icon>
              </div>
            </div>
            <div class="row offsetrow">
              <div id="passed80percent" class="col-8 text-left">
                <!--Passed (80% or Higher at Least Once):-->
                Passed (Scored 80% or Higher):
              </div>
              <div class="col-4 text-right">
                {{Passed}} <font-awesome-icon icon="user" @click="showPopLogin(4)" size="lg" title="Users who have received scores using the product(s) during the selected time filter, and at least one score was 80 or higher during that timeframe."></font-awesome-icon>
              </div>
            </div>
          </div>
          <div class="scoreGraph dashbox moduleCard mt-2" v-if="avgscoredata!==null&&avgscoreoptions!==null">
            <h3 id="memberscores" class="text-center">Member Scores</h3>
            <dash-line :data="avgscoredata" :options="avgscoreoptions"></dash-line>
          </div>
        </div>
        <div class="col-4">
          <div class="performersData dashhead moduleCard" v-if="hasCompData===true">
            <b-form-select v-model="PerformerVisibility" class="mb-1">
              <b-form-select-option :value="0" id="topperformer">Top Performers</b-form-select-option>
              <b-form-select-option :value="1" id="bottomperformer">Bottom Performers</b-form-select-option>
            </b-form-select>
            <div v-if="PerformerVisibility===0">
              <div v-for="item in TopPerformers">
                <div v-bind:class="{row:true, offsetrow:isOffsetRow(item.Num)}">
                  <div class="col-1 smtext">
                    {{item.Num}}.
                  </div>
                  <div class="col-9 smtext">
                    {{item.Name}}
                  </div>
                  <div class="col-2 smtext">
                    {{item.Score}}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="PerformerVisibility===1">
              <div v-for="item in BottomPerformers">
                <div v-bind:class="{row:true, offsetrow:isOffsetRow(item.Num)}">
                  <div class="col-1 smtext">
                    {{item.Num}}.
                  </div>
                  <div class="col-9 smtext">
                    {{item.Name}}
                  </div>
                  <div class="col-2 smtext">
                    {{item.Score}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="passFailGraph dashbox moduleCard mt-2" v-if="doughnutdata!==null&&doughnutoptions!==null">
            <h3 id="memberpassfail" class="text-center">Member Passes/Fails</h3>
            <dash-doughnut :data="doughnutdata" :options="doughnutoptions"></dash-doughnut>
          </div>
        </div>
      </div>
      <b-modal ref="rProducts" id="lProducts" title="Select Products" size="xl" @ok="filterProducts">
        <p id="lProductsMessage">When combining products: statistics are inclusive (e.g. number of members that launched Products A and B is the number of members that launched Products A <u>and</u> B, not the number of members that launched Product A plus the number of members that launched Product B)</p>
        <genericlist ref="rProdGeneric" :items="pureproducts" :displayType="'2'" :preSelected="multiProducts" :mode="'message'"></genericlist>
      </b-modal>
      <b-modal id="lGroups" title="Select Groups" size="xl" @ok="filterGroups">
        <genericlist ref="rGroupsGeneric" :items="groups" :displayType="'2'" :preSelected="multiGroups" :mode="'message'"></genericlist>
      </b-modal>
      <b-modal ref="rPopList" title="Members" scrollable ok-only size="xl" id="members_model">
        <div v-for="item in poplist" class="row">
          <div class="col-6 text-left">
            <a :href="'/client/'+item.ID">{{item.Name}}</a>
          </div>
          <div class="col-6 text-right" v-html="item.MetaData">           
          </div>
        </div>
      </b-modal>
      <b-modal ref="rTime" id="customTimeframe" title="Select Date Range" @ok="filterDate">
        <div class="row">
          <div class="col-6 text-center">
            <div id="start_date">Start Date</div>
            <v-date-picker v-model="startdate" :locale="userLocale"></v-date-picker>
          </div>
          <div class="col-6 text-center">
            <div id="end_date">End Date</div>
            <v-date-picker v-model="enddate" :locale="userLocale"></v-date-picker>
          </div>

        </div>
      </b-modal>
    </div>
    <div v-if="noProducts===true">
      The dashboard is not available because there are no products associated with this License Pool
    </div>
  </div>
</template>

<style scoped>

  .dashboardHeader button, .dashboardHeader select {
    width: inherit !important;
  }

  .dashboardHeader button {
    padding: 8px 20px !important;
  }

  .offsetrow {
    background: #EEE;
  }

  .smtext {
    font-size: 11px;
  }

  svg[data-icon="user"] {
    cursor: pointer;
  }
</style>

<script>
  import genericlist from './GenericList.vue';
  import DashDoughnut from '../mixins/DashDoughnut.js';
  import DashLine from '../mixins/DashLine.js';
  import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels';
  import * as mylib from '../languageText.js';

  Chart.plugins.register(ChartJsPluginDataLabels);

  export default {
    name: 'UnifiedDash',
    components: { DashDoughnut, DashLine, genericlist, ChartJsPluginDataLabels },
    props: [
      "LicensePoolID",
      "mode"
    ],
    data() {
      return {
        avgscoredata: null,
        avgscoreoptions: null,
        compdata: null,
        compoptions: null,
        dashHasData: false,
        hasCompData: false,
        startdate: new Date(),
        enddate: new Date(new Date().getTime() + 2592000000),
        sdelta: -1,
        gdata: null,
        dashDelta: "1209600000",
        doughnutdata: null,
        doughnutoptions: null,
        poplist: [],
        presets: {
          red: 'rgb(255, 99, 132)',
          orange: 'rgb(255, 159, 64)',
          yellow: 'rgb(255, 205, 86)',
          green: 'rgb(75, 192, 192)',
          blue: 'rgb(54, 162, 235)',
          purple: 'rgb(153, 102, 255)',
          grey: 'rgb(201, 203, 207)'
        },
        products: [],
        pureproducts: [],
        groups: [],
        multiGroups: [],
        multiProducts: [],
        noProducts: false,
        selectedProduct: null,

        LoggedIn: null,
        DidNotLogin: null,
        NeverStarted: null,
        DidNotComplete: null,
        Passed: null,
        Failed: null,
        BottomPerformers: [],
        TopPerformers: [],
        PerformerVisibility: 0,
        userLocale: "en" // Default locale
      }
    },
    methods: {
      averageScoreGraph() {

        this.avgscoredata = null;
        this.avgscoreoptions = null;

        var lbls = [];
        var highscores = [];
        var lowscores = [];
        var averagescores = [];
        var hasData = false;

        for (var ldate in this.gdata.ScoresByDate) {
          if (this.gdata.ScoresByDate.hasOwnProperty(ldate)) {
            var dt = this.buildDateTime(ldate, false);
            var highScore = 0;
            var lowScore = 100;

            if (this.gdata.ScoresByDate[ldate].Max > 0) {
              hasData = true;
            }

            highscores.push(this.gdata.ScoresByDate[ldate].Max);
            lowscores.push(this.gdata.ScoresByDate[ldate].Min);
            averagescores.push(this.gdata.ScoresByDate[ldate].Average);

            lbls.push(dt);
          }
        }

        if (hasData) {

          this.avgscoredata = {
            labels: lbls,
            datasets: [{
              backgroundColor: this.makeTransparent(this.presets.green),
              borderColor: this.presets.green,
              data: highscores,
              label: this.languageTrsnalate('High Score'),
              fill: 0
            },
            {
              backgroundColor: this.makeTransparent(this.presets.orange),
              borderColor: this.presets.orange,
              data: averagescores,
              label: this.languageTrsnalate('Mean Score'),
              fill: 0
            }, {
              backgroundColor: this.makeTransparent(this.presets.red),
              borderColor: this.presets.red,
              data: lowscores,
              label: this.languageTrsnalate('Low Score'),
              fill: 0
            }]
          };

          this.avgscoreoptions = {
            maintainAspectRatio: false,
            spanGaps: false,
            plugins: {
              datalabels: {
                display: false
              }
            },
            elements: {
              line: {
                tension: 0.000001
              }
            },
            scales: {

              xAxes: [{
                type: 'time',
                time: {
                  time: {
                    unit: 'day'
                  }
                }
              }],

              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          };
        }

      },
      languageTrsnalate(inputText) {
        //alert(sessionStorage.getItem("userLanguage"));
        if (sessionStorage.getItem("userLanguage") != null) {
          const language = sessionStorage.getItem("userLanguage");
          var returnVal = "";
          if (language.includes("Espanol") || language.includes("Spanish")) {
            switch (inputText) {
              case 'High Score': returnVal = 'Puntuación alta'; break;
              case 'Mean Score': returnVal = 'Puntuación media'; break;
              case 'Low Score': returnVal = 'Puntuación baja'; break;
              case 'Pass': returnVal = 'Satisfactorio'; break;
              case 'Fail': returnVal = 'Insatisfactorio'; break;
              case 'Launches': returnVal = 'Lanzamientos'; break;
              case 'Combined Products': returnVal = 'Productos combinados'; break;
            }
          } else { returnVal = inputText; }
        } else { returnVal = inputText; }
        return returnVal;
      },
      buildDashForProduct() {

        this.LoggedIn = this.gdata.LoggedInMembers.length;
        this.DidNotLogin = this.gdata.DidNotLogIn.length;

        this.NeverStarted = this.gdata.NeverStarted.length;
        this.StartedButNoScore = this.gdata.StartedButNoScore.length;

        this.averageScoreGraph();
        this.launchGraph();
        this.passFailGraph();

        this.Passed = this.gdata.PassedAllTraining.length;
        this.Failed = this.gdata.NotPassedAllTraining.length;

        this.TopPerformers = [];
        this.BottomPerformers = [];

        if (this.gdata.BottomPerformers["00000000-0000-0000-0000-000000000000"].length > 0) {
          for (var x = 0; x < this.gdata.BottomPerformers["00000000-0000-0000-0000-000000000000"].length; x++) {
            this.BottomPerformers.push({
              Num: x + 1,
              Name: this.gdata.BottomPerformers["00000000-0000-0000-0000-000000000000"][x].Value,
              Score: this.gdata.BottomPerformers["00000000-0000-0000-0000-000000000000"][x].Key.toFixed(2)
            });
          }
        }

        if (this.gdata.TopPerformers["00000000-0000-0000-0000-000000000000"].length > 0) {
          for (var x = 0; x < this.gdata.TopPerformers["00000000-0000-0000-0000-000000000000"].length; x++) {
            this.TopPerformers.push({
              Num: x + 1,
              Name: this.gdata.TopPerformers["00000000-0000-0000-0000-000000000000"][x].Value,
              Score: this.gdata.TopPerformers["00000000-0000-0000-0000-000000000000"][x].Key.toFixed(2)
            });
          }
        }

        this.hasCompData = this.TopPerformers.length > 0;
        this.dashHasData = true;


        Window.loadLanguageContent();
      },
      clearFilters() {
        this.sdelta = -1;
        this.dashDelta = "2592000000";
        this.startdate = new Date();
        this.enddate = new Date(new Date().getTime() + 2592000000);
        this.multiProducts = [];
        this.multiGroups = [];
        this.selectedProduct = null;

        if (this.products.length > 1) {

          this.selectedProduct = this.products[1].value;

          this.renderDashboard();
        }
      },
      doCustomProduct() {
        if (this.selectedProduct === this.emptyguid) {
          this.$refs["rProducts"].show();
        }
        else if (this.selectedProduct !== null) {
          this.renderDashboard();
        }
        Window.loadLanguageContent();
      },
      openGroupsModel() {
        Window.loadLanguageContent();
      },

      filterDate() {
        this.sdelta = new Date().getTime() - this.enddate.getTime();
        this.renderDashboard(this.enddate.getTime() - this.startdate.getTime());
      },
      filterGroups() {
        this.multiGroups = this.$refs["rGroupsGeneric"].getResult();
        this.renderDashboard();

      },
      filterProducts() {
        this.multiProducts = this.$refs["rProdGeneric"].getResult();
        this.renderDashboard();
      },
      isOffsetRow(n) {
        if (n === 1 || n % 2 === 1) return true;
        return false;
      },
      launchGraph() {

        this.compdata = null;
        this.compoptions = null;

        var lbls = [];
        var launches = [];
        var completions = [];
        var hasLaunches = false;

        for (var ldate in this.gdata.LaunchesByDate) {
          if (this.gdata.LaunchesByDate.hasOwnProperty(ldate)) {
            var dt = this.buildDateTime(ldate, false);

            if (this.gdata.LaunchesByDate[ldate].Value > 0) {
              hasLaunches = true;
            }

            lbls.push(dt);
            launches.push(this.gdata.LaunchesByDate[ldate].Value);
          }
        }

        if (hasLaunches) {

          this.compdata = {
            labels: lbls,
            datasets: [{
              backgroundColor: this.makeTransparent(this.presets.grey),
              borderColor: this.presets.grey,
              data: launches,
              label: this.languageTrsnalate('Launches'),
              fill: 0
            }]
          };

          this.compoptions = {
            maintainAspectRatio: false,
            spanGaps: false,
            plugins: {
              datalabels: {
                display: false
              }
            },
            elements: {
              line: {
                tension: 0.000001
              }
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true
                }
              }]
            }
          };
        }


      },
      passFailGraph() {

        var totalPasses = 0;
        var totalFails = 0;
        this.doughnutdata = null;
        this.doughnutoptions = null;

        for (var productid in this.gdata.PassPercentage) {
          if (this.gdata.PassPercentage.hasOwnProperty(productid)) {

            totalPasses += this.gdata.PassPercentage[productid];

          }
        }

        for (var productid in this.gdata.FailPercentage) {
          if (this.gdata.FailPercentage.hasOwnProperty(productid)) {

            totalFails += this.gdata.FailPercentage[productid];

          }
        }

        if (totalPasses > 0 || totalFails > 0) {

          this.doughnutdata = {
            datasets: [{
              data: [
                totalPasses, totalFails
              ],
              backgroundColor: [
                this.presets.green,
                this.presets.red,
              ],
            }],
            labels: [
              this.languageTrsnalate('Pass'),
              this.languageTrsnalate('Fail'),
            ]
          };

          this.doughnutoptions = {
            maintainAspectRatio: false,
            legend: {
              position: 'top',
            },
            animation: {
              animateScale: true,
              animateRotate: true
            },
            plugins: {
              datalabels: {
                display: true,
                align: 'bottom',
                backgroundColor: '#ccc',
                borderRadius: 3,
                font: {
                  size: 18,
                }
              }
            }
          };
        }


      },
      makeTransparent(color, opacity) {
        var alpha = opacity === undefined ? 0.5 : 1 - opacity;
        return Color(color).alpha(alpha).rgbString();
      },
      renderDashboard(odelta) {

        var d = this.dashDelta;
        if (typeof (odelta) !== "undefined" && odelta !== null) {
          d = odelta;
        }

        var prRange = [];
        if (this.selectedProduct === null) {
          return;
        }
        else if (this.selectedProduct === this.emptyguid) {
          prRange = this.multiProducts;
        }
        else {
          prRange.push(this.selectedProduct);
        }

        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetDashboard",
            Fields: {
              LicensePoolID: this.LicensePoolID,
              Delta: d,
              SDelta: this.sdelta,
              LimitGroups: this.multiGroups.join(","),
              LimitProducts: prRange.join(",")
            }
          }
        ]).then(response => {
          if (response !== null) {
            try {
              var cr = JSON.parse(response.CommandResult);
              this.gdata = JSON.parse(cr.returnObjects[0].returnObject);

              this.buildDashForProduct();

            }
            catch (e) {
              console.log(e);
            }
          }
        });
      },
      selectTime() {
        if (this.dashDelta === "custom") {
          this.$refs["rTime"].show();
        }
        else {
          this.sdelta = -1;
          this.renderDashboard();
        }

        const userLanguage = sessionStorage.getItem("userLanguage");
        if (userLanguage) {
          this.userLocale = userLanguage === "Espanol" ? "es" : "en"; // Default to English if not "Espanol"
        }   
        Window.loadLanguageContent();
      },
      showPopLogin(id) {
        this.poplist = [];

        if (id === 0) {
          this.poplist = this.gdata.LoggedInMembers;
        }
        else if (id === 1) {
          this.poplist = this.gdata.DidNotLogIn;
        }
        //else if (id === 2) {
        //  this.poplist = this.gdata.AttemptedAllTraining;
        //}
        //else if (id === 3) {
        //  this.poplist = this.gdata.NotAttemptedAllTraining;
        //}
        else if (id === 4) {
          this.poplist = this.gdata.PassedAllTraining;
        }
        else if (id === 5) {
          this.poplist = this.gdata.NotPassedAllTraining;
        }
        else if (id === 6) {
          this.poplist = this.gdata.NeverStarted;
        }
        else if (id === 7) {
          this.poplist = this.gdata.StartedButNoScore;
        }


        this.$refs["rPopList"].show();
        Window.loadLanguageContent();
      },
      loadDropdowns() {
        var cmd = [
          {
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.LicensePoolID,
              IncludeChildren: "true",
              ExcludeParents: "true",
              IncludeBundles: "true",
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          }

        ];

        if (this.mode === '0') {
          cmd.push({
            Operation: "LicensePool",
            Function: "GetGroups",
            Fields: {
              LicensePoolID: this.LicensePoolID
            }
          });
        }
        else {
          this.multiGroups = [this.mode];
        }

        this.apiCommand(cmd).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var eproducts = JSON.parse(cr.returnObjects[0].returnObject);

          this.products.push({
            text: "--- Select ---",
            value: null
          })

          for (var item of eproducts) {
            if (this.pureproducts.filter(p => p.value === item.ProductID).length === 0) {
              this.products.push({
                text: item.ProductName,
                value: item.ProductID
              });
              this.pureproducts.push({
                text: item.ProductName,
                value: item.ProductID
              });
            }
          }

          if (this.mode === '0') {
            var egroups = JSON.parse(cr.returnObjects[1].returnObject);

            for (var item of egroups) {
              this.groups.push({
                text: item.LicensePoolGroupName,
                value: item.LicensePoolGroupID
              });
            }
          }

          if (this.products.length > 1) {
            this.products.push({
              text: this.languageTrsnalate("Combined Products"),
              value: this.emptyguid
            })

            this.selectedProduct = this.products[1].value;
            this.renderDashboard();

          }
          else {
            this.noProducts = true;
          }
        });
      }
    },
    mounted() {

      var _ref = this;

      if (sessionStorage.getItem("userLanguageID") == null) {

        var ClientID = '';

        if (typeof (localStorage.getItem("udata")) !== "undefined") {
          var udata = JSON.parse(localStorage.getItem("udata"));
          ClientID = udata.ClientID;
        }

        var hostname;
        if (window.location.origin.indexOf("admin.simmersion.com") > -1) {
          hostname = "https://tcapi.simmersion.net";
        }
        else {
          hostname = "https://tcapi.simmersionstage.net";
        }

        // Creating Our XMLHttpRequest object
        let xhr = new XMLHttpRequest();

        // Making our connection
        let url = hostname + '/SSO.svc/GetLanguageByClientID?ClientID=' + ClientID;
        xhr.open("GET", url, true);


        // function execute after request is successful
        xhr.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var language = this.responseText.replace('<string xmlns="http://schemas.microsoft.com/2003/10/Serialization/">', '').replace('</string>', '');


            let languageName = language.split('@@@')[0];
            let languageID = language.split('@@@')[1];

            sessionStorage.setItem("userLanguage", languageName);
            sessionStorage.setItem("userLanguageID", languageID); //Set a default language as English ID

            _ref.loadDropdowns();

          } else {
            console.log("Error occured while fetching user information from TCAPI.");
          }

        }
        // Sending our request
        xhr.send();
      }
      else {
        this.loadDropdowns();
      }
    }
  }

</script>
